
	import { Options, Vue } from 'vue-class-component'
	import MenuArea from '../components/MenuArea.vue'
	@Options({
		components: {
			MenuArea
		}
	})
	export default class HomeView extends Vue {
		steps = [
			{
				id: 1,
				content: "トークボタンを押して、ひぐまさんにモヤモヤしていることを話してみよう",
				message: "なんでも言ってみ！"
			},
			{
				id: 2,
				content: "お話しの内容から、ひぐまさんがお悩みを予想します",
				message: "モヤモヤポイントはここか？"
			},
			{
				id: 3,
				content: "お悩みが少し楽になりそうな情報を探してくるよ！",
				message: "20％くらい楽になるかもな"
			},
		]
		promise = [
			{ 
				id: 1,
				title: "ニンゲンは聞いてません!",
				content: "あなたがお話ししてしてくれたことを、こっそり誰かが聞いている、、、なんてことはありません！聴いているのはひぐまさんだけです!"
			},
			{ 
				id: 2,
				title: "どんなことでも否定しません!",
				content: "モヤモヤしていること、言葉にするのってすごく大変。だから、正しく伝えようなんて思わなくても大丈夫。今の気持ちをぐちゃぐちゃのままお話ししてみてね"
			},
			{ 
				id: 3,
				title: "一生懸命さがします!",
				content: "あなたが話してくれたことのなかから、キーワードを探して、「こんなことで悩んでいるのかな？」と予想します。そこから役に立ちそうな情報や投稿を探してくるよ"
			},
		]
		scrollY = 0
		get isMenuShow(): boolean {
				return this.scrollY > 300
		}
		async mounted() {
			window.onscroll = this.handleScroll
		}
		handleScroll() {
			this.scrollY = window.scrollY
		}
	}
